module.exports = __webpack_public_path__ + "src/assets/img/meetingList_hallway.126499b8.jpg";